import { isMobileAtom, Styles, useRecoil } from '@orcar/common-d2c';
import styled from 'styled-components';
import GalaxyLogo from '@/assets/img/galaxy_logo.png';
import MobileLogo from '@/assets/img/jejuro_mobile_black_logo.png';
import { useBusinessProfile } from '@/hooks/useSiteProfile';
import CompanyInfoSection from './CompanyInfoSection';
import LinkButtonSection from './LinkButtonSection';
import SocialLinks from './SocialLinks';
import * as S from '../styles';

const MobileFooter = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  const { rentalOperators, copyright } = useBusinessProfile();
  return (
    <Wrapper>
      <TopSection>
        <S.FooterLogos>
          <img src={MobileLogo} alt='mobile-footer로고' />
          <img src={GalaxyLogo} width={84} alt='갤럭시렌트카 로고' />
        </S.FooterLogos>
        <LinkButtonSection isMobile={isMobile} />
        <CompanyInfoSection isMobile={isMobile} />
        <SocialLinks isMobile={isMobile} />
      </TopSection>
      <S.BottomSection isMobile={isMobile}>
        {rentalOperators && (
          <S.RentalOperator>대여사업자 : {rentalOperators}</S.RentalOperator>
        )}
        {copyright && (
          <S.InfoContent color={Styles.COLOR.GREY_01}>
            {copyright}
          </S.InfoContent>
        )}
      </S.BottomSection>
    </Wrapper>
  );
};

export default MobileFooter;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 0 0;
  border-top: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
`;

const TopSection = styled.div`
  padding: 0 20px;
`;
